<template>
  <base-home-page background="/capsiminbox/images/Capsim_Inbox_Demo_Welcome_Bg.png">
    <div id="user-form">
      <h1 class="mt-0 mb-15 text-center bold-text">Access Demo</h1>
      <form>
        <div
          v-for="(input, key) in user"
          :key="input + key"
          :class="['form-group', { 'has-error': errors[key] }]"
        >
          <base-input
            :label="input.label"
            :id="input.label.split(' ').join('-')"
            v-model="input.val"
            :placeholder="input.label"
            :error="errors[key]"
            required
          />
        </div>
        <span class="text-danger"
          >Note: Please be aware that this demo of CapsimInbox is not meant to be shared with
          students.</span
        >
        <br />
        <br />
        <button class="btn btn-primary submit align-center pr-15 pl-15" @click.prevent="submit">
          <span class="start-demo-text" style>Start Demo</span>
        </button>
        <div class="clearfix"></div>
      </form>
    </div>
  </base-home-page>
</template>

<script>
  import BaseHomePage from '@shared/BaseHomePage.vue';
  export default {
    name: 'welcome',

    components: {
      BaseHomePage,
    },

    data() {
      return {
        windowHeight: 0,
        user: {
          firstname: {
            val: '',
            label: 'First Name',
            validate() {
              return this.val.length >= 3;
            },
          },
          lastname: {
            val: '',
            label: 'Last Name',
            validate() {
              return this.val.length >= 3;
            },
          },
          email: {
            val: '',
            label: 'Email',
            validate() {
              return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.val);
            },
          },
          school: {
            val: '',
            label: 'Institution/Organization',
            validate() {
              return this.val.length > 3;
            },
          },
        },
        errors: {},
      };
    },

    methods: {
      submit() {
        const payload = {
          firstname: this.user.firstname.val,
          lastname: this.user.lastname.val,
          email: this.user.email.val,
          school: this.user.school.val,
        };

        this.validateForm()
          .then(() => this.$store.dispatch('SET_USER', payload))
          .then(() => this.$router.push({ name: 'assessment' }))
          .catch(() => console.log('Error'));
      },

      validateForm() {
        return new Promise((resolve, reject) => {
          this.$set(this.$data, 'errors', {});
          let hasErrors = false;
          Object.keys(this.user).forEach((input) => {
            if (!this.user[input].validate()) {
              this.errors[input] = `Please enter a valid ${this.user[input].label.toLowerCase()}`;
              hasErrors = true;
            }
          });
          return hasErrors ? reject() : resolve();
        });
      },
    },
    mounted() {
      const demoEmail = this.$store.state.demoEmail;
      if (!demoEmail) this.$router.push({ name: 'assessment' });
    },
  };
</script>

<style lang="scss" scoped>
  .user-info {
    float: none;
    margin-left: auto;
    margin-right: auto;
    margin-top: 30px;
    box-shadow: 0px 0px 15px 1px rgba(118, 118, 118, 0.36);

    .submit {
      height: 50px;
      border-radius: 10px;
      background: #33cc99;

      .start-demo-text {
        font-size: 16px;
        letter-spacing: 1px;
        color: black;
        font-weight: bold;
      }
    }
  }

  label {
    font-size: 1.3em;
    &::after {
      content: '*';
      color: red;
    }
  }

  input {
    box-shadow: 1px 1px #cfd1d6;
    height: 50px;
    font-size: 18px;
  }
</style>
